import React from "react";

import LegalPage from "./LegalPage";

const TermsAndConditionsPage: React.FC = () => {
  return (
    <LegalPage
      title="Terms of use"
      lastUpdated="ll"
      backLabel="Go to login"
      sections={[
        {
          heading: "Introduction",
          body: [
            "Addyou is an app and web based tool for Android and iOS that provide positive and strengthening support for the individual in everyday life.",
            "In the app you can:",
          ],
          bullets: [
            "Insert goals that follow the implementation plan.",
            "Create linking activities with relevant support such as checklists, push notes and helping comments.",
          ],
        },
        {
          heading: "Web",
          body: [
            "In the web part you can:",
          ],
          bullets: [
            "Follow the development of the business at different levels of eligibility.",
            "See Privacy Policy on https://app.addyou.se/privacy-policy",
            "The following conditions are valid and legally binding on all users of Addyou. You must accept the terms and conditions before you can use the service.",
          ],
        },
        {
          heading: "Subscription",
          body: [
            "The subscription starts automatically after an agreed start date between both parties and continues without notification of renewal until you cancel. You will be charged for the current subscription period according to the business's selected subscription plan. It is your business's responsibility to terminate your subscription in writing through admin@addyou.se",
            "Pay subscriptions cannot be terminated before the expiry of the period already paid. AY PLUS AB will not repay fees that you have already paid. A non-payment allows AY Plus AB to deactivate an account.",
          ],
        },
        {
          heading: "Cancellation",
          body: [
            "It is your responsibility as a business to terminate your subscription through admin@addyou.se",
            "After termination, the subscription will be paid after 1 month. Your business will be charged for the current subscription period. AY Plus AB will not repay fees already paid.",
          ],
        },
        {
          heading: "Data",
          body: [
            "We take your privacy and your data protection very seriously. We share and/or analyze your personal information only in the limited scenarios and for the limited purpose explained in our privacy policy. By using Addyou, you consent to the collection and use of personal information in accordance with our privacy policy.",
          ],
        },
        {
          heading: "Maintenance and stability",
          body: [
            "The Addyou tool is continuously developing. AY Plus reserves the right to update and change the content of the service. AY Plus AB strives for the best possible maintenance stability but is not responsible for any interruptions or accidents caused by circumstances outside AY Plus AB's control. This is, but not limited to, power outages, internet connection problems, hardware problems, hacker attacks, viruses or other types of force majeure.",
          ],
        },
        {
          heading: "Responsibility",
          body: [
            "The use of Addyou takes place at your own risk and AY Plus is not responsible to your business or anyone else about:",
          ],
          bullets: [
            "Disruptions or damage to your computer systems occur",
            "You suffer from any loss, cost or cost associated with your use of our service.",
          ],
        },
        {
          heading: "Responsibility",
          body: [
            "The use of Addyou takes place at your own risk and AY Plus is not responsible to your business or anyone else about:",
          ],
          bullets: [
            "Disruptions or damage to your computer systems occur",
            "You suffer from any loss, cost or cost associated with your use of our service.",
            "All direct or indirect losses",
            "Damage, costs or expenses that occur in connection with the use of addyou.",
            "AY PLUS AB agrees to use commercially reasonable technical and organizational measures designed to:",
            "Prevent unauthorized access",
            "Use, change or disclosure of any service or customer data.",
            "However, AY Plus AB will have no responsibility for:",
            "Error in the transfer",
            "Unauthorized access from third party",
            "Other reasons outside AY Plus AB's control",
            "All data is stored securely to prevent unauthorized access from third parties.",
            "AY Plus AB cannot be held responsible for errors that arise from circumstances outside AY Plus AB's control, including but not limited to:",
            "Power failure",
            "Problems with internet connection",
            "Problems with hardware",
            "Hacker attacks",
            "Viruses or other types of force majeure",
          ],
        },
        {
          heading: "",
          body: [
            "We reject all responsibility for direct or indirect losses, and for damage, costs or expenses that occur in connection with the use of addyou.",
          ],
        },
        {
          heading: "Data security",
          body: [
            "When your business registers to use Addyou, the contact person from your part fills in a registration form with name and e-mail address. This information will be stored in order to provide you with the best possible service. When you create a subscription at Addyou, your payment information is handled via monthly invoicing with 30 days of payment terms. Addyou only stores if you have an active or inactive subscription, and none of your payment details. Customer business accepts that AY Plus AB has the right to use third-party suppliers in all circumstances, including development, maintenance and data storage. These are located in Sweden. All data is owned by AY Plus AB. For more information about the processing of your data, see our privacy policy.",
          ],
        },
        {
          heading: "Changes",
          body: [
            "AY Plus AB reserves the right to change and update these terms of use. AY Plus AB also reserves the right to make price changes with at least 30 days warning. Your business will be notified of significant changes via email.",
          ],
        },
      ]}
    />
  );
};

export default TermsAndConditionsPage;
